import { FC } from "react";

const style = {
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
  padding: "0.5em",
};

const ContainerFluid: FC = ({ children }) => {
  return <div style={style}>{children}</div>;
};

export default ContainerFluid;
